// components

// react
import { useEffect, useState } from 'react';

// kendo

import {
  Chart,
  ChartSeries,
  ChartSeriesItem,
  ChartCategoryAxis,
  ChartCategoryAxisItem,
  ChartValueAxis, ChartValueAxisItem,
  ChartTooltip,
} from "@progress/kendo-react-charts";

// css
import styles from './userMonitor_mobile.module.css';

// services

function UserMonitorChartMobile({dataSource, search}) {


  const [data, setData] = useState({
    categories: [],
    series: [],
  })

  const [step, setStep] = useState({
    min: 0,
    max: 0,
    majorUnit: 0,
    step: 0,
  })

  // 데이터 셋팅
  const makeData = () => {
    // 초기값이 객체기때문에 형식을 지켜준것이다.
    if(search.dataType === "movement") {
      setData(
        {categories: dataSource.movement.map(({name}) => name),
        series: dataSource.movement.map(({y}) => y)}
      );
    } else if(search.dataType === "temperature") {
      setData(
        {categories: dataSource.temperature.map(({name}) => name),
        series: dataSource.temperature.map(({y}) => y)}
      );
    } else if(search.dataType === "humidity") {
      setData(
        {categories: dataSource.humidity.map(({name}) => name),
        series: dataSource.humidity.map(({y}) => y)}
      );
    } else if(search.dataType === "co2") {
      setData(
        {categories: dataSource.co2.map(({name}) => name),
        series: dataSource.co2.map(({y}) => y)}
      );
    } else if(search.dataType === "light") {
      setData(
        {categories: dataSource.light.map(({name}) => name),
        series: dataSource.light.map(({y}) => y)}
      );
    } else if(search.dataType === "velocityTotal") {
      setData(
        {categories: dataSource.velocityTotal.map(({name}) => name),
        series: dataSource.velocityTotal.map(({y}) => y)}
      );
    } else {
      setData(
        {categories: [],
        series: []}
      );
    }
  }

  // 차트 최소값, 최대값, 간격 설정
  const makeStep = () => {
    if(search.dataType === "movement") {
      setStep(
        {min: 0, max: 500, majorUnit: 100}
      );
    } else if(search.dataType === "temperature") {
      setStep(
        {min: 0, max: 40, majorUnit: 4}
      );
    } else if(search.dataType === "humidity") {
      setStep(
        {min: 0, max: 0, majorUnit: 4}
      );
    } else if(search.dataType === "co2") {
      setStep(
        {min: 0, max: 0, majorUnit: 500}
      );
    } else if(search.dataType === "light") {
      setStep(
        {min: 0, max: 0, majorUnit: 100}
      );
    } else if(search.dataType === "velocityTotal") {
      setStep(
        {min: 0, max: 500, majorUnit: 100}
      );
    } else {
      setStep(
        {min: 0, max: 0, majorUnit: 0}
      );
    }

    if(search.dateType === "HH") {
      setStep(step => {
        const item = { ...step };
        item.step = 4;
        return item;
      })
    } else if(search.dateType === "DD") {
      setStep(step => {
        const item = { ...step };
        item.step = 2;
        return item;
      })
    } else if(search.dateType === "MM") {
      setStep(step => {
        const item = { ...step };
        item.step = 6;
        return item;
      })
    }
  }

  const tooltipFormat = () => {
    return "NO";
  }

  useEffect(() => {
    makeData();
    makeStep();
  },[dataSource])

  return (
    <>
      <Chart style={{ height: '30vh' }}>
        <ChartTooltip
          background="#5e9dd4"
          color="#fff"
          font="14px Arial, sans-serif"
          format={tooltipFormat()}
          visible={true}
        />
        <ChartCategoryAxis>
          <ChartCategoryAxisItem
            labels={{step: step.step}}
            categories={data.categories}
            categoryField="category"
            // axisCrossingValue={data.categories.length}
            majorGridLines={{visible: false}}
            />
        </ChartCategoryAxis>
        <ChartSeries>
          <ChartSeriesItem
            data={data.series}
            type="line"
            color={"#5e9dd4"}
            tooltip={{
              visible: true,
            }}
            markers={{
              visible: false,
            }}
            style="smooth"
          />
        </ChartSeries>
        <ChartValueAxis>
          <ChartValueAxisItem
            // majorUnit={step.majorUnit} 
            labels={{
              step: 2
            }}
          />
        </ChartValueAxis>
      </Chart>
    </>
  );
}

export default UserMonitorChartMobile;
